import * as React from 'react';
import * as styles from '../styles.scss';
import { Dropdown, Fallback } from 'components/common';
import { IState } from 'redux/global-reducers';
import * as classNames from 'classnames';
import { WithNamespaces, withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { handleError } from 'utils/common';
import { withErrorBoundary } from 'react-error-boundary';
import {
  DERIVATIVES_CONDITIONAL_TYPE,
  IOrderForm,
  IOrderFormConfig,
  OrderFormFieldKey,
} from '../config';
import { FormikErrors } from 'formik';

interface IConditionalTypeSectionProps
  extends React.ClassAttributes<ConditionalTypeComponent>,
    WithNamespaces {
  readonly config: IOrderFormConfig;
  readonly values: IOrderForm;
  readonly onChangeConditionType: (title: string, value: string) => void;

  readonly ErrorMessage: React.FC<{
    readonly message?: string;
  }>;
  readonly errors: FormikErrors<IOrderForm>;
}

class ConditionalTypeComponent extends React.Component<
  IConditionalTypeSectionProps
> {
  render() {
    const {
      t,
      config,
      ErrorMessage,
      errors,
      values,
      onChangeConditionType,
    } = this.props;
    return (
      <>
        {config[OrderFormFieldKey.CONDITIONAL_TYPE] != null && (
          <div
            className={classNames(styles.ConditionalSection, styles.FormField)}
            style={config[OrderFormFieldKey.CONDITIONAL_TYPE]?.style}
          >
            <div className={styles.MainField}>
              <div className={styles.FieldTitle}>{t('Conditional Type')}</div>
              <div
                className={classNames(styles.FieldInput, styles.MarginTop16)}
              >
                <Dropdown
                  isForm={true}
                  data={DERIVATIVES_CONDITIONAL_TYPE}
                  onSelect={onChangeConditionType}
                  activeItem={values.conditionalType}
                />
              </div>
            </div>

            <ErrorMessage message={errors.conditionalType} />
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state: IState) => ({});

const mapDispatchToProps = {};

const ConditionalTypeSection = withErrorBoundary(
  withNamespaces('common')(
    connect(mapStateToProps, mapDispatchToProps)(ConditionalTypeComponent)
  ),
  Fallback,
  handleError
);

export default ConditionalTypeSection;



// WEBPACK FOOTER //
// ./src/components/common/OrderForm/FormSection/ConditionalType.tsx